/**
 * Copie la chaine de caractères dans le presse-papier
 * @param {string} str Chaine à copier
 */
export default async function clipboard(str: string, toastManager: Object, message: string) {
  const successMessage = message ? message : 'Copié !';
  const fallbackPromptMessage = 'Copie manuelle : sélectionnez puis faites Ctrl+C / Cmd+C';

  const onSuccess = () => {
    toastManager.add(successMessage, {
      appearance: 'success',
      autoDismiss: true,
      pauseOnHover: false,
      autoDismissTimeout: 1500
    });
  };

  const onError = (e) => {
    console.log(e);
    toastManager.add('Erreur de copiage...', {
      appearance: 'error',
      autoDismiss: true,
      pauseOnHover: false,
      autoDismissTimeout: 1500
    });
  };

  const legacyCopy = () => {
    const textarea = document.createElement('textarea');
    textarea.value = str;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.top = '0';
    textarea.style.left = '0';
    textarea.style.opacity = '0';
    textarea.style.pointerEvents = 'none';
    textarea.style.zIndex = '-1';

    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    textarea.setSelectionRange(0, textarea.value.length);

    const copied = document.execCommand('copy');
    document.body.removeChild(textarea);

    if (!copied) {
      throw new Error('document.execCommand(copy) failed');
    }
  };

  const manualCopy = () => {
    const wrapper = document.createElement('div');
    const closeButton = document.createElement('button');
    const label = document.createElement('div');
    const textarea = document.createElement('textarea');

    wrapper.style.position = 'fixed';
    wrapper.style.top = '50%';
    wrapper.style.left = '50%';
    wrapper.style.transform = 'translate(-50%, -50%)';
    wrapper.style.width = 'min(90vw, 640px)';
    wrapper.style.padding = '16px';
    wrapper.style.background = '#fff';
    wrapper.style.border = '1px solid #d0d7de';
    wrapper.style.borderRadius = '8px';
    wrapper.style.boxShadow = '0 12px 32px rgba(0, 0, 0, 0.18)';
    wrapper.style.zIndex = '2147483647';

    closeButton.type = 'button';
    closeButton.setAttribute('aria-label', 'Fermer');
    closeButton.textContent = '\u00d7';
    closeButton.style.position = 'absolute';
    closeButton.style.top = '8px';
    closeButton.style.right = '10px';
    closeButton.style.width = '32px';
    closeButton.style.height = '32px';
    closeButton.style.border = '0';
    closeButton.style.borderRadius = '16px';
    closeButton.style.background = 'transparent';
    closeButton.style.color = '#57606a';
    closeButton.style.cursor = 'pointer';
    closeButton.style.fontSize = '24px';
    closeButton.style.lineHeight = '28px';
    closeButton.style.padding = '0';

    label.textContent = fallbackPromptMessage;
    label.style.paddingRight = '32px';
    label.style.marginBottom = '8px';
    label.style.fontSize = '14px';
    label.style.color = '#1f2328';

    textarea.value = str;
    textarea.rows = Math.max(4, Math.min(str.split('\n').length + 1, 12));
    textarea.style.width = '100%';
    textarea.style.minHeight = '120px';
    textarea.style.boxSizing = 'border-box';

    wrapper.appendChild(closeButton);
    wrapper.appendChild(label);
    wrapper.appendChild(textarea);
    document.body.appendChild(wrapper);

    textarea.focus();
    textarea.select();
    textarea.setSelectionRange(0, textarea.value.length);

    const remove = () => {
      if (wrapper.parentNode) {
        wrapper.parentNode.removeChild(wrapper);
      }
      document.removeEventListener('keydown', onKeyDown, true);
      wrapper.removeEventListener('click', onWrapperClick, true);
    };

    const onKeyDown = (event) => {
      if (event.key === 'Escape' || event.key === 'Enter') {
        remove();
      }
    };

    const onWrapperClick = (event) => {
      if (event.target === wrapper) {
        remove();
      }
    };

    document.addEventListener('keydown', onKeyDown, true);
    wrapper.addEventListener('click', onWrapperClick, true);
    closeButton.addEventListener('click', remove, true);
  };

  const copyToClipboard = async () => {
    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
      try {
        await navigator.clipboard.writeText(str);
        return;
      } catch (e) {
        if (!e || e.name !== 'NotAllowedError') {
          throw e;
        }
      }
    }

    try {
      legacyCopy();
    } catch (e) {
      manualCopy();
    }
  };

  if (getMobileOperatingSystem() === 'Android') {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ clipboard: str }));
      onSuccess();
    } else {
      try {
        await copyToClipboard();
        onSuccess();
      } catch (e) {
        onError(e);
      }
    }
  } else {
    try {
      await copyToClipboard();
      onSuccess();
    } catch (e) {
      onError(e);
    }
  }
}

//Récupère l'OS du smartphone de l'utilisateur
function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone';
  }

  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  // iOS detection
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS';
  }

  return 'unknown';
}
